(function () {
  "use strict";

  var reward = document.querySelector("[data-ish-survey-pdp-price]");
  var api = window.InShapeSurveyReward;
  if (!reward || !api) return;

  // Keep the original 2+ resolver unchanged; the wear lane verifies its own saved reward.
  var wearAccess = null;
  var legacyLaunch = window.__inshapeSurveyLaunch || {};
  if (!legacyLaunch.hasRewardParam && !legacyLaunch.hasCodeParam && !legacyLaunch.rewardError) {
    try {
      var staffRaw = sessionStorage.getItem("inshape-wear-staff-qa-v1");
      var wearToken = sessionStorage.getItem("inshape-wear-reward-v3-token");
      if (staffRaw) {
        var staff = JSON.parse(staffRaw);
        wearAccess = { staff: true, token: staff.token, runId: staff.runId };
      } else if (wearToken) {
        wearAccess = { staff: false, token: wearToken, source: sessionStorage.getItem("inshape-wear-reward-v3-source") === "campaign_email" ? "campaign_email" : "evergreen_email" };
      }
    } catch (_) { wearAccess = { invalid: true }; }
  }
  var wearMode = Boolean(wearAccess);
  if (wearMode) {
    var originalApi = api;
    api = {
      applyState: originalApi.applyState,
      track: function (name, details, state) {
        if (wearAccess.staff || state && Date.parse(state.displayExpiresAt) <= Date.now()) return Promise.resolve();
        return originalApi.track(name.replace(/^survey_/, "wear_survey_"), details, state);
      },
      resolve: async function () {
        var unavailable = { valid: false, status: "unavailable", reason: "wear_reward_unavailable" };
        if (wearAccess.invalid) return unavailable;
        var origin = "https://inshape-first-purchase-survey.mftwice.chatgpt.site";
        var url = new URL(wearAccess.staff ? "/api/wear-staff-qa" : "/api/response", origin);
        var headers = { Accept: "application/json" };
        if (wearAccess.staff) {
          if (!/^[A-Za-z0-9_-]{32,128}$/.test(wearAccess.token || "") || !/^[A-Za-z0-9][A-Za-z0-9_-]{15,79}$/.test(wearAccess.runId || "")) return unavailable;
          url.searchParams.set("action", "response");
          headers["X-InShape-Wear-Staff-QA"] = wearAccess.token;
          headers["X-InShape-Wear-Staff-Run"] = wearAccess.runId;
        } else {
          if (typeof wearAccess.token !== "string" || wearAccess.token.length > 1500 || !/^[A-Za-z0-9_-]+\.[A-Za-z0-9_-]+$/.test(wearAccess.token)) return unavailable;
          url.searchParams.set("token", wearAccess.token);
          url.searchParams.set("source", wearAccess.source);
        }
        try {
          var response = await fetch(url.href, { method: "GET", credentials: "omit", cache: "no-store", referrerPolicy: "no-referrer", headers: headers, signal: AbortSignal.timeout(12000) });
          if (!response.ok) return unavailable;
          var record = await response.json();
          if (record.ok !== true || record.questionnaire !== "wear" || record.surveyVersion !== "first_purchase_wear_v3" || record.completed !== true) return unavailable;
          var grantExpiry = Infinity;
          if (wearAccess.staff) {
            var grant = record.staffQa;
            grantExpiry = Date.parse(grant && grant.expiresAt || "");
            if (record.isTest !== true || !grant || grant.scope !== "existing-staff-reward" || grant.runId !== wearAccess.runId || !Number.isFinite(grantExpiry) || grantExpiry <= Date.now() || grantExpiry > Date.now() + 30 * 60000) return unavailable;
          } else if (record.isTest !== false) return unavailable;
          var candidate = record.reward;
          var issued = Date.parse(candidate && candidate.issuedAt || ""), expiry = Date.parse(candidate && candidate.expiresAt || "");
          if (!candidate || candidate.status !== "active" || candidate.redeemed === true || candidate.amount !== 30 || candidate.minimum !== 0 || candidate.includesFreeShipping !== false
            || !/^FIRST30-[A-Z0-9]{16}$/.test(candidate.code || "") || !Number.isFinite(issued) || !Number.isFinite(expiry) || issued > Date.now() + 1000 || expiry <= Date.now() || Math.abs(expiry - issued - 14 * 86400000) > 1000) return unavailable;
          return { valid: true, status: "active", source: wearAccess.staff ? "wear_staff_qa" : "wear_" + wearAccess.source, code: candidate.code, expiresAt: candidate.expiresAt,
            displayExpiresAt: new Date(Math.min(expiry, grantExpiry)).toISOString(), amount: 30, currency: "USD", minimumSubtotal: 0, includesFreeShipping: false };
        } catch (_) { return unavailable; }
      }
    };
  }

  var storageKey = reward.dataset.storageKey || "inshape-survey-reward-v1";
  var defaultAmount = Number(reward.dataset.defaultAmount || 50);

  api.resolve({
    storageKey: storageKey,
    defaultAmount: defaultAmount,
    currency: reward.dataset.currency || "USD"
  }).then(function (state) {
    if (!state.valid || state.status !== "active") {
      api.applyState(state);
      return;
    }

    api.applyState(state);
    if (wearMode && wearAccess.staff) {
      var staffNotice = document.createElement("aside");
      staffNotice.setAttribute("role", "status");
      staffNotice.textContent = "Staff QA · original test reward. Customer launch remains paused.";
      staffNotice.style.cssText = "padding:14px 20px;background:#fff7d6;color:#252525;text-align:center;font:600 14px/1.5 sans-serif";
      document.body.insertBefore(staffNotice, document.body.firstChild);
    }
    function displayActive() {
      if (!wearMode || Date.parse(state.displayExpiresAt) > Date.now()) return true;
      reward.hidden = true;
      var container = reward.closest(".product-price-container");
      if (container) container.classList.remove("ish-survey-price-active");
      var mobile = document.querySelector("[data-ish-survey-mobile-buybar]");
      if (mobile) mobile.hidden = true;
      document.body.classList.remove("ish-survey-discount-confirmed", "ish-survey-buybar-visible");
      api.applyState({ valid: false, status: "expired" });
      return false;
    }
    if (wearMode) setTimeout(displayActive, Math.max(1, Date.parse(state.displayExpiresAt) - Date.now()));

    var currency = reward.dataset.currency || state.currency || "USD";
    var currencyRate = Number(window.Shopify && window.Shopify.currency && window.Shopify.currency.rate) || 1;
    var amountRate = state.currency === currency ? 1 : currencyRate;
    var amountCents = Math.round(state.amount * 100 * amountRate);
    var expiresAt = Date.parse(state.expiresAt);
    var value = reward.querySelector("[data-ish-survey-pdp-value]");
    var totalLabel = reward.querySelector("[data-ish-survey-pdp-total-label]");
    var listValue = reward.querySelector("[data-ish-survey-pdp-list]");
    var packPrice = reward.querySelector("[data-ish-survey-pdp-pack]");
    var amountLabel = reward.querySelector("[data-ish-survey-pdp-amount]");
    var codeLabel = reward.querySelector("[data-ish-survey-pdp-code]");
    var status = reward.querySelector("[data-ish-survey-pdp-status]");
    var note = reward.querySelector("[data-ish-survey-pdp-note]");
    var priceContainer = reward.closest(".product-price-container");
    var buybar = document.querySelector("[data-ish-survey-mobile-buybar]");
    var buybarPrice = buybar && buybar.querySelector("[data-ish-survey-mobile-price]");
    var buybarSelection = buybar && buybar.querySelector("[data-ish-survey-mobile-selection]");
    var buybarAction = buybar && buybar.querySelector("[data-ish-survey-mobile-action]");
    var primaryAdd = document.querySelector("#survey-purchase [name='add']");
    var sizeFieldset = document.querySelector("#survey-purchase fieldset[data-handle='size']");
    var colorFieldset = document.querySelector("#survey-purchase fieldset[data-handle='color'], #survey-purchase fieldset[data-handle*='color']");
    var labelChooseSize = reward.dataset.labelChooseSize || "Choose your size";
    var labelAdd = reward.dataset.labelAdd || "Add to cart";
    var isConfirmed = false;
    var hasTrackedAdd = false;

    function formatMoney(cents) {
      try {
        return new Intl.NumberFormat(document.documentElement.lang || undefined, {
          style: "currency",
          currency: currency,
          minimumFractionDigits: 2
        }).format(cents / 100);
      } catch (_) {
        return "$" + (cents / 100).toFixed(2);
      }
    }

    function formatDate(timestamp) {
      if (!Number.isFinite(timestamp)) return "";
      try {
        return new Intl.DateTimeFormat(document.documentElement.lang || undefined, { month: "short", day: "numeric" }).format(new Date(timestamp));
      } catch (_) {
        return "";
      }
    }

    function checkedValue(fieldset) {
      var checked = fieldset && fieldset.querySelector("input:checked");
      return checked ? checked.value : "";
    }

    function updateSelectionSummary() {
      if (!buybarSelection || !buybarAction) return;
      var color = checkedValue(colorFieldset);
      var size = checkedValue(sizeFieldset);
      buybarSelection.textContent = [color, size || labelChooseSize].filter(Boolean).join(" · ");
      buybarAction.textContent = size ? labelAdd : labelChooseSize;
    }

    function updateConfirmation(confirmed, source) {
      if (!displayActive() || !confirmed || isConfirmed) return;
      isConfirmed = true;
      reward.classList.add("is-confirmed");
      document.body.classList.add("ish-survey-discount-confirmed");
      if (totalLabel) totalLabel.textContent = reward.dataset.labelConfirmedTotal || "Your total";
      if (note) note.textContent = reward.dataset.labelConfirmedNote || "Reward confirmed in cart.";
      api.track("survey_discount_confirmed", {
        page_type: "survey_product",
        confirmation_source: source,
        product_handle: reward.dataset.productHandle || ""
      }, state);
    }

    function render(basePriceCents, compareAtPriceCents) {
      if (!displayActive()) return;
      var priceCents = Number(basePriceCents);
      var compareAtCents = Number(compareAtPriceCents);
      if (!Number.isFinite(priceCents) || priceCents <= 0) return;
      if (!Number.isFinite(compareAtCents) || compareAtCents <= 0) compareAtCents = priceCents;

      var discountedCents = Math.max(0, priceCents - amountCents);
      if (value) value.textContent = formatMoney(discountedCents);
      if (listValue) listValue.textContent = formatMoney(compareAtCents);
      if (packPrice) packPrice.textContent = formatMoney(priceCents);
      if (amountLabel) amountLabel.textContent = "−" + formatMoney(amountCents);
      if (codeLabel) { codeLabel.textContent = wearMode ? "" : state.code; codeLabel.hidden = wearMode; }
      if (buybarPrice) buybarPrice.textContent = formatMoney(discountedCents);
      if (totalLabel && !isConfirmed) totalLabel.textContent = reward.dataset.labelEstimatedTotal || "Estimated after reward";
      if (note && !isConfirmed) note.textContent = reward.dataset.labelEstimatedNote || "Your reward will be verified when it is applied in cart.";

      if (status) {
        var parts = [reward.dataset.labelActive || "Reward active"];
        var expiryDate = formatDate(expiresAt);
        if (expiryDate) parts.push((reward.dataset.labelExpires || "Expires __DATE__").replace("__DATE__", expiryDate));
        parts.push(formatMoney(Math.round(state.minimumSubtotal * 100 * amountRate)) + " minimum");
        status.textContent = parts.join(" · ");
      }

      if (priceContainer) priceContainer.classList.add("ish-survey-price-active");
      reward.hidden = false;
      if (buybar) buybar.hidden = false;
      updateSelectionSummary();
    }

    function cartHasReward(cart) {
      var applications = [].concat(cart && cart.cart_level_discount_applications || []);
      (cart && cart.items || []).forEach(function (item) {
        applications = applications.concat(item.line_level_discount_allocations || []);
      });
      return applications.some(function (entry) {
        var application = entry.discount_application || entry;
        return String(application.title || "").trim().toUpperCase() === state.code;
      });
    }

    function verifyCart() {
      if (!displayActive()) return Promise.resolve(false);
      return fetch((window.theme && window.theme.routes && window.theme.routes.cart_url || "/cart") + ".js", {
        credentials: "same-origin",
        headers: { Accept: "application/json" }
      }).then(function (response) {
        if (!response.ok) throw new Error("cart_unavailable");
        return response.json();
      }).then(function (cart) {
        if (!displayActive()) return false;
        var confirmed = cartHasReward(cart);
        if (confirmed) updateConfirmation(true, "shopify_cart");
        return confirmed;
      }).catch(function () { return false; });
    }

    function focusSizeChoice() {
      if (!sizeFieldset) return;
      sizeFieldset.scrollIntoView({ behavior: "smooth", block: "center" });
      var firstSize = sizeFieldset.querySelector("input[type='radio']:not([disabled])");
      if (firstSize) window.setTimeout(function () { firstSize.focus(); }, 350);
    }

    if (buybarAction) {
      buybarAction.addEventListener("click", function () {
        if (!displayActive()) return;
        if (!checkedValue(sizeFieldset)) {
          focusSizeChoice();
          return;
        }
        if (primaryAdd && !primaryAdd.disabled) primaryAdd.click();
      });
    }

    if (primaryAdd) {
      primaryAdd.addEventListener("click", function () {
        if (!hasTrackedAdd) {
          hasTrackedAdd = true;
          api.track("survey_add_to_cart", {
            product_handle: reward.dataset.productHandle || "",
            variant_selection: [checkedValue(colorFieldset), checkedValue(sizeFieldset)].filter(Boolean).join(" / ")
          }, state);
        }
        window.setTimeout(verifyCart, 700);
        window.setTimeout(verifyCart, 1800);
      });
    }

    if (primaryAdd && buybar && "IntersectionObserver" in window) {
      var addObserver = new IntersectionObserver(function (entries) {
        var show = displayActive() && !entries[0].isIntersecting;
        buybar.classList.toggle("is-visible", show);
        document.body.classList.toggle("ish-survey-buybar-visible", show);
      }, { threshold: 0.25 });
      addObserver.observe(primaryAdd);
    } else if (buybar) {
      buybar.classList.add("is-visible");
      document.body.classList.add("ish-survey-buybar-visible");
    }

    document.addEventListener("change", function (event) {
      if (!event.target || !event.target.closest("#survey-purchase .variations")) return;
      updateSelectionSummary();
      api.track("survey_variant_selected", {
        product_handle: reward.dataset.productHandle || "",
        option_name: event.target.name || "",
        option_value: event.target.value || ""
      }, state);
    });

    document.addEventListener("click", function (event) {
      if (event.target.closest('[name="checkout"], a[href*="/checkout"]')) {
        api.track("survey_checkout_started", { page_type: "survey_product" }, state);
      }
    });

    var upnovaEnabled = reward.dataset.upnovaGoalsEnabled !== "false" && (!window.InShapeSurveyFeatures || window.InShapeSurveyFeatures.upnovaGoals !== false);
    if (upnovaEnabled) {
      var upnovaRoot = null;
      var upnovaRootObserver = null;
      var upnovaTimer = null;

      function scanUpnova() {
        if (!displayActive()) return false;
        upnovaTimer = null;
        var widget = document.querySelector("upnova-widget#upezCart");
        var root = widget && widget.shadowRoot;
        if (!root) return false;
        var hasSurveyDiscount = String(root.textContent || "").toUpperCase().indexOf(state.code) !== -1;
        widget.toggleAttribute("data-ish-survey-discount", hasSurveyDiscount);
        if (hasSurveyDiscount) {
          var style = root.querySelector("#ish-survey-upnova-goals");
          if (!style) {
            style = document.createElement("style");
            style.id = "ish-survey-upnova-goals";
            style.textContent = ":host([data-ish-survey-discount]) .upez__shop_progress_pristine{display:none!important}";
            root.appendChild(style);
          }
          updateConfirmation(true, "upnova_cart");
        }
        if (upnovaRoot !== root) {
          if (upnovaRootObserver) upnovaRootObserver.disconnect();
          upnovaRoot = root;
          upnovaRootObserver = new MutationObserver(function () {
            if (upnovaTimer === null) upnovaTimer = window.setTimeout(scanUpnova, 100);
          });
          upnovaRootObserver.observe(root, { childList: true, subtree: true, characterData: true });
        }
        return true;
      }

      if (!scanUpnova()) {
        var upnovaAttempts = 0;
        var upnovaInterval = window.setInterval(function () {
          upnovaAttempts += 1;
          if (scanUpnova() || upnovaAttempts >= 60) window.clearInterval(upnovaInterval);
        }, 250);
      }
    }

    render(reward.dataset.priceCents, reward.dataset.compareAtCents);
    verifyCart();
    api.track("survey_pdp_viewed", {
      product_handle: reward.dataset.productHandle || "",
      reward_amount: state.amount,
      reward_source: state.source
    }, state);

    document.addEventListener("product:variant-change", function (event) {
      var detail = event.detail || {};
      if (detail.sectionId !== reward.dataset.sectionId || !detail.variant) return;
      render(detail.variant.price, detail.variant.compare_at_price);
      updateSelectionSummary();
    });
  });
})();
